module.exports = __webpack_public_path__ + "static/img/4.a4d9995.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/zh/4.png
// module id = E2rn
// module chunks = 0